export default __webpack_public_path__ + "static/media/privacypolicy.2c43b39e.pdf";